import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseFunctions';

interface DismissEmailAnalysisRequest {
  analysisId: string;
  reason?: string;
}

export const dismissEmailAnalysis = async (
  request: DismissEmailAnalysisRequest,
): Promise<{ success: boolean }> => {
  const callable = httpsCallable<DismissEmailAnalysisRequest, { success: boolean }>(
    functions,
    'dismissEmailAnalysis',
  );
  const result = await callable(request);
  return result.data;
};
